import React from 'react'
import { InputField } from 'components/inputs'
import { DATE_INPUT_SUPPORTED } from './dateInputSupport'
import { FallbackDatePicker } from './FallbackDatePicker'

interface DatePickerProps {
  id?: string
  label?: string
  min?: string
  max?: string
  defaultValue?: string
  pattern?: string
}

export const DatePicker: React.FunctionComponent<
  DatePickerProps & JSX.IntrinsicElements['input']
> = (props) => {
  if (DATE_INPUT_SUPPORTED) {
    return (
      <InputField
        type="date"
        minDate={props.min}
        maxDate={props.max}
        {...props}
      />
    )
  }
  return <FallbackDatePicker {...props} />
}
